import React from "react";
import { Card } from "@/components/ui/card";

/** Compact stat card used on the top grid of the admin dashboard. */
export function Stat({ label, value, icon: Ic, tone = "primary" }) {
  return (
    <Card className="p-5 border-border/60">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-[0.16em] text-muted-foreground">{label}</div>
          <div className="font-heading text-3xl mt-1">{value?.toLocaleString?.() ?? value}</div>
        </div>
        <div className={`h-10 w-10 rounded-xl flex items-center justify-center bg-${tone}/15 text-${tone}`}>
          <Ic className="h-5 w-5 text-primary" />
        </div>
      </div>
    </Card>
  );
}
